import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0949328"
import script from "./question.js?vue&type=script&lang=js&external"
export * from "./question.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports